"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aliasResolver = aliasResolver;
exports.defaultNamespaceResolver = defaultNamespaceResolver;
exports.default = textResolver;
const enums_1 = require("@aurora/shared-client/enums");
const ApiHelper_1 = require("@aurora/shared-client/helpers/ApiHelper");
const assets_1 = require("@aurora/shared-types/assets");
const enums_2 = require("@aurora/shared-types/overrides/enums");
const enums_3 = require("@aurora/shared-types/pages/enums");
const ModuleHelper_1 = __importDefault(require("@aurora/shared-utils/helpers/modules/ModuleHelper"));
const ObjectHelper_1 = require("@aurora/shared-utils/helpers/objects/ObjectHelper");
const log_1 = require("@aurora/shared-utils/log");
const endUserModuleRegistry_1 = require("../../../features/endUserModuleRegistry");
const sharedModuleRegistry_1 = require("@aurora/shared-client/sharedModuleRegistry");
const log = (0, log_1.getLog)(module);
const customPageModulePath = (0, endUserModuleRegistry_1.getModulePathForComponent)(enums_3.EndUserComponent.CUSTOM_PAGE);
/**
 * returns namespace for the given alias. If not found then null is returned.
 * @param alias
 */
function aliasResolver(alias) {
    const componentId = (0, ObjectHelper_1.enumFromValue)(enums_3.EndUserComponent, alias);
    if (componentId) {
        return (0, endUserModuleRegistry_1.getModulePathForComponent)(componentId);
    }
    else {
        if (alias.startsWith(enums_3.EndUserComponent.CUSTOM_PAGE)) {
            const [, pageId] = alias.split(enums_3.EndUserComponent.CUSTOM_PAGE + '.');
            return (0, endUserModuleRegistry_1.getModulePathForComponent)(enums_3.EndUserComponent.CUSTOM_PAGE, pageId);
        }
        else {
            const sharedComponentId = (0, ObjectHelper_1.enumFromValue)(enums_1.SharedComponent, alias);
            if (sharedComponentId) {
                return (0, sharedModuleRegistry_1.getModulePathForComponent)(sharedComponentId);
            }
            return null;
        }
    }
}
function defaultNamespaceResolver(namespace) {
    if (namespace.startsWith(customPageModulePath)) {
        return customPageModulePath;
    }
    return namespace;
}
let assetCaches;
function getText(locale, namespaces, client, tenant, lastModified) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window === 'undefined') {
            if (!assetCaches) {
                assetCaches = (yield ModuleHelper_1.default.unwrapDynamicImport(Promise.resolve().then(() => __importStar(require('@aurora/shared-server/server/assets/assetCaches'))), 'getAssetCaches'))();
            }
            const cachedText = yield assetCaches.textCache.findTextBundles(() => Promise.resolve(client), tenant, locale, aliasResolver, defaultNamespaceResolver, namespaces, false, lastModified);
            return cachedText === null || cachedText === void 0 ? void 0 : cachedText.texts;
        }
        else {
            return (0, ApiHelper_1.getCachedAssetFromApi)(enums_2.CachedAssetType.TEXT, [locale, namespaces.join(',')], lastModified);
        }
    });
}
function textResolver(_1, _a, _b) {
    return __awaiter(this, arguments, void 0, function* (_, { locale, namespaces, lastModified = assets_1.LastModifiedKeys.DEFAULTS_ONLY }, { client, tenant }) {
        const now = performance.now();
        const { id: tenantId } = tenant;
        log.trace('Resolving texts for namespaces: %O, locale: %s and tenant %s', namespaces, locale, tenantId);
        const texts = yield getText(locale, namespaces, client, tenant, lastModified);
        log.trace('Texts resolved for namespaces: %O, locale: %s and tenant %s in %dms', namespaces, locale, tenantId, performance.now() - now);
        return texts;
    });
}
//# sourceMappingURL=textResolver.js.map